'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var APPLICATION_MODE = exports.APPLICATION_MODE = {
    development: 'development',
    test: 'test',
    production: 'production'
};

var DEBUG_LEVEL = exports.DEBUG_LEVEL = {
    OFF: 0,
    // Always show errors
    ERROR: 0,
    WARN: 100,
    INFO: 200,
    FINE: 300,
    FINER: 400,
    FINEST: 500
};

var ENV = exports.ENV = {
    PRODUCTION: 'production',
    DEVELOPMENT: 'development'
};

var SERVER_TYPE = exports.SERVER_TYPE = {
    development: 'development',
    staging: 'staging',
    production: 'production'
};


//////////////////
// WEBPACK FOOTER
// ./config/configConstants.js
// module id = 135
// module chunks = 0